import { Paper, Stack, Typography } from '@mui/material'
import { tsGetLinesInRack } from '../../../../Typescript/API_Response'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { stackGap } from '../../../../Constants&Theme/Spacing'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'

function RackCard({
  rackQuery,
  index,
}: {
  rackQuery: UseQueryResult<tsGetLinesInRack, AxiosResponse<any, any>>
  index: number
}) {
  return (
    <Paper
      key={index}
      elevation={3}
      sx={{ width: 1, p: 2, display: 'flex' }}
    >
      <Stack
        gap={stackGap.col / 2}
        width={1}
      >
        <Typography variant={'h6'}>{rackQuery.data?.rack?.RackName}</Typography>
        <DataGridPro
          loading={rackQuery.isLoading}
          getRowId={(row) => row?.LineID ?? row?.ShortLineName}
          columns={[
            {
              field: 'ZoneID',
              headerName: 'Zone ID',
              flex: 1,
            },
            {
              field: 'LineID',
              headerName: 'Line ID',
              flex: 1,
            },
            {
              field: 'ShortLineName',
              headerName: 'Line Name',
              flex: 3,
            },
          ]}
          rows={rackQuery.data?.lines ?? []}
          hideFooter
          autoHeight
          density={'compact'}
        />
      </Stack>
    </Paper>
  )
}

export default RackCard
